import { action, thunk } from 'easy-peasy';
import { api } from '../services/api';


const videoModel = {
    videos: [],
    isLoading: false,

    setLoading: action((state, payload) => {
        state.isLoading = payload;
    }),

    setVideos: action((state, payload) => {
        state.videos = payload;
    }),
    fetchVideos: thunk(async (actions) => {
        try {
            actions.setLoading(true);
            const response = await api.fetchVideos();
            actions.setVideos(JSON.parse(response.videos));
        } catch (error) {
            console.error('Failed to fetch videos:', error);
        } finally {
            actions.setLoading(false);
        }
    }),

};

export default videoModel;